// Prize categories — MUST stay in sync with backend constants/prizeCategories.ts
// (final list per Terra, 2026-07-14).
// To add a new category: add a row HERE and in the backend file (+ the member
// frontends' copies), then deploy.
export const PRIZE_CATEGORIES = [
	{ id: 'shopping', he: 'אופנה ותכשיטים', en: 'Fashion & Jewelry' },
	{ id: 'leisure_culinary', he: 'בילויים וקולינריה', en: 'Leisure & Culinary' },
	{ id: 'wellness_care', he: 'וולנס וטיפוח', en: 'Wellness & Self-Care' },
	{ id: 'culture_learning', he: 'תרבות ולמידה', en: 'Culture & Learning' },
	{ id: 'gifts', he: 'מתנות', en: 'Gifts' },
	{ id: 'advisors_therapists', he: 'יועצים ומטפלים', en: 'Advisors & Therapists' },
].map((c) => ({ ...c, name: `${c.he} · ${c.en}` }));

export const prizeCategoryLabel = (slug?: string) =>
	PRIZE_CATEGORIES.find((c) => c.id === slug)?.he ?? '—';
